import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { BottomNavbar, Header } from './components';
import { AlertProvider } from '@ui/pages/Alerts/AlertContext';
const MobileLayout = ({ children }) => {
    return (_jsx(_Fragment, { children: _jsxs(AlertProvider, { children: [_jsx(Header, {}), _jsx(Outlet, {}), _jsx(BottomNavbar, {})] }) }));
};
export default MobileLayout;
